// https://github.com/blakeembrey/change-case/blob/main/packages/title-case/src/index.ts
const LOWERCASE_WORDS = new Set([
  "a",
  "an",
  "and",
  "as",
  "at",
  "because",
  "but",
  "by",
  "en",
  "for",
  "if",
  "in",
  "neither",
  "nor",
  "of",
  "on",
  "only",
  "or",
  "over",
  "per",
  "so",
  "some",
  "than",
  "that",
  "the",
  "to",
  "up",
  "upon",
  "versus",
  "via",
  "vs",
  "when",
  "with",
  "without",
  "yet",
]);

const UPPERCASE_WORDS = new Set(["IHG", "AT&T"]);

function shouldTitleCaseAmpersandWord(word: string): boolean {
  return /^[a-z]+(?:&[a-z]+)+$/.test(word);
}

function toTitleCaseAmpersandWord(word: string): string {
  return word
    .split("&")
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join("&");
}

export function toTitleCase(str: string): string {
  let firstWordSeen = false;

  return str.toLowerCase().replace(/\S+/g, (word) => {
    // Always uppercase specific words and pattern matches.
    if (UPPERCASE_WORDS.has(word.toUpperCase())) {
      firstWordSeen = true;
      return word.toUpperCase();
    }

    if (shouldTitleCaseAmpersandWord(word)) {
      firstWordSeen = true;
      return toTitleCaseAmpersandWord(word);
    }

    // Always capitalize the first word
    if (!firstWordSeen) {
      firstWordSeen = true;
      return word.charAt(0).toUpperCase() + word.slice(1);
    }

    // Keep small words lowercase
    if (LOWERCASE_WORDS.has(word)) {
      return word;
    }

    // Capitalize other words
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
}
